import user from './slices/user'
import dataExplorer from './slices/dataExplorer'
import ui from './slices/ui'
import dashboard from './slices/dashboard'
import query from './slices/query'

export const reducerList = {
  user,
  dataExplorer,
  ui,
  dashboard,
  query
}

export type ReducerType = {
  [Key in keyof typeof reducerList]: ReturnType<(typeof reducerList)[Key]>
}

export default reducerList
